module.exports = "<imr-popup options=\"$ctrl.popupOptions\">\r\n    {{$ctrl.content}}\r\n</imr-popup>"